import React from 'react';
import { SortCaret } from 'components/shell/Icons';

/**
 * Column heading that sorts. UI refresh (Aaron, 5 Nov 2026): the same size and colour as every other
 * heading (see HEADING_STYLE), with a small solid caret instead of the large hollow arrow.
 */
export const HEADING_STYLE: React.CSSProperties = {
  fontSize: 12,
  fontWeight: 600,
  letterSpacing: '0.02em',
  color: 'rgba(255,255,255,0.86)',
  lineHeight: '16px',
  whiteSpace: 'nowrap',
};

type Props = {
  text: string;
  onClick(newState: 'asc' | 'desc'): void;
  state?: 'asc' | 'desc';
};

export const SortTextButton: React.FC<Props> = ({ text, onClick, state }) => {
  const click = () => {
    onClick(!state ? 'asc' : state === 'asc' ? 'desc' : 'asc');
  };
  return (
    <button
      type="button"
      className="archy-sort"
      onClick={click}
      aria-label={`Sort by ${text}${state ? (state === 'asc' ? ', ascending' : ', descending') : ''}`}
      style={{
        ...HEADING_STYLE,
        ...(state ? { color: '#FFFFFF' } : {}),
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: 0,
        border: 'none',
        background: 'transparent',
        // fontFamily only: a `font` shorthand here would reset the heading size and weight above.
        fontFamily: 'inherit',
        cursor: 'pointer',
        justifySelf: 'start',
      }}
    >
      {text}
      {state && <SortCaret dir={state} size={8} />}
    </button>
  );
};
